import { request } from '../http';
const ABTEST_URL = '/api/uis/accounts/current/abtest';
globalThis._abtests = globalThis._abtests || {};
export let AbTestGroups = /*#__PURE__*/function (AbTestGroups) {
  AbTestGroups["OUT_OF_TEST"] = "outOfTest";
  AbTestGroups["CONTROL"] = "control";
  AbTestGroups["VARIATION_A"] = "variationA";
  AbTestGroups["VARIATION_B"] = "variationB";
  AbTestGroups["VARIATION_C"] = "variationC";
  return AbTestGroups;
}({});
export async function evaluateGroupForTest(abTestKey, forceDraw) {
  if (forceDraw === void 0) {
    forceDraw = true;
  }
  if (globalThis._abtests[abTestKey]) {
    return globalThis._abtests[abTestKey];
  }
  if (!forceDraw) {
    return AbTestGroups.OUT_OF_TEST;
  }
  try {
    const {
      data: {
        value
      }
    } = await request({
      url: `${ABTEST_URL}/${abTestKey}`
    });
    globalThis._abtests[abTestKey] = value;
    return value;
  } catch (err) {
    return null;
  }
}
//# sourceMappingURL=index.js.map